// Shared between the growth comparison chart and table so both always agree
// on the day axis and on which batch represents each breed's ideal curve.

export const getMaxDay = (data) =>
  Math.max(
    ...data.map((batch) =>
      batch.days && batch.days.length > 0 ? batch.days[batch.days.length - 1] : 0
    )
  );

// One ideal curve per distinct breed — same-breed batches share the same
// reference. Returns Map(breedName -> {batch, nonNullCount}), where batch is
// the one with the most complete idealWeights series for that breed.
export const getBreedIdealSeries = (data) => {
  const breedIdeals = new Map();
  data.forEach((batch) => {
    if (!batch.idealWeights || !batch.idealWeights.some((w) => w != null)) {
      return;
    }
    const breed = batch.breedName || "Unknown breed";
    const existing = breedIdeals.get(breed);
    const nonNullCount = batch.idealWeights.filter((w) => w != null).length;
    if (!existing || nonNullCount > existing.nonNullCount) {
      breedIdeals.set(breed, { batch, nonNullCount });
    }
  });
  return breedIdeals;
};
